<div
  class="select-primary-image-button"
  [ngClass]="{
    'select-primary-image-button--selected': selected(),
  }"
>
  <button
    class="select-primary-image-button__action"
    (click)="selectItem.emit()"
    [disabled]="disabled()"
  >
    @if (selected() && !labelBottom()) {
      <span>
        {{ 'common.selectPrimaryImageButton.primary' | translate }}
      </span>
    }

    @if (!selected()) {
      <fr8bot-ui-icon name="start-border" [size]="16" />
    }
    @if (selected()) {
      <fr8bot-ui-icon name="start-fill" [size]="16" />
    }
  </button>

  @if (selected() && labelBottom()) {
    <span
      class="select-primary-image-button__labelBottom select-primary-image-button__labelBottom--primary"
    >
      {{ 'common.selectPrimaryImageButton.primaryPhoto' | translate }}
    </span>
  }
  @if (!selected() && labelBottom()) {
    <span
      class="select-primary-image-button__labelBottom select-primary-image-button__labelBottom--hover"
    >
      {{ 'common.selectPrimaryImageButton.makePrimary' | translate }}
    </span>
  }
</div>
